module.exports = __webpack_public_path__ + "img/img2.08e1471c.svg";